import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfirmationDialogService } from '../common-components/confirmation-dialog/confirmation-dialog.service';
import { DialogSize } from '../common-components/confirmation-dialog/enumerations/dialog-size.enum';
import { ConfirmationDialogType } from '../common-components/confirmation-dialog/models/confirmation-dialog.config';
import { FormComponent } from '../common-components/forms-base/form-component.interface';

@Injectable({ providedIn: 'root' })
export class ComponentCanDeactivateGuard {
   constructor(private confirmationDialogService: ConfirmationDialogService, private router: Router) {}

   canDeactivate(component: FormComponent): Observable<boolean> | Promise<boolean> | boolean {
      if (component.form && component.form.dirty) {
         const currentNavigation = this.router.currentNavigation();
         const bypassDeactivate = currentNavigation?.extras.state?.bypassDeactivate;
         if (bypassDeactivate) {
            return true;
         }

         const dialogRef = this.confirmationDialogService.confirm({
            data: {
               header: 'Leave Page?',
               message: 'Unsaved changes will be lost.',
               dialogType: ConfirmationDialogType.YesNo,
            },
            size: DialogSize.Medium,
         });

         return dialogRef.afterClosed().pipe(map((confirmed) => !!confirmed));
      }
      return true;
   }
}
